import React, { Component } from 'react';
import axios from 'axios'

import Basic from '../container/layouts/Basic';
import Button from '@mui/material/Button';
import DoughnutChart from './Stats/DoughnutChart';
import { Grid, Typography } from '@mui/material';

class HomePage extends Component {
    state = {  }
    
    render() {
        return (
            <Basic title="Home" {...this.props}>
                <Typography variant="h5" style={{textAlign: "center", margin: "25px 0 40px"}}>Répartition des Dépenses</Typography>
                <DoughnutChart view="USER"/>
            </Basic>
        );
    }
}

export default HomePage;